import { useState } from 'react'

export const InquiriesState = () => {
    const [inquiry, setInquiry] = useState({
        author_id: null,
        form: {
            toggled: false,
            inputs: {
                file: {value: null, object: null, name: '', type: '', size: 0, updated: false, stat: false, msg: ''},
                value: ''
            }
        }
    })
    return {
        inquiry : { data: inquiry, set: setInquiry},
    }
}
